import { motion } from "framer-motion";

const events = [
    {
        title: "Out Pouring Of The Holy Spirit",
        description:
            "The Holy Spirit descends upon the gathered brethren, filling every soul with fire, power and the divine presence of the Most High God.",
        vidlink: "https://youtube.com/embed/SOJhRqd3rUE",
        tag: "Spiritual",
    },
    {
        title: "The King of Kings And The Lord of Lords Coronation",
        description:
            "A sacred ceremony marking the divine coronation of His Holiness Olumba Olumba Obu — the Sole Spiritual Head of the Universe.",
        vidlink: "https://youtube.com/embed/zW8exoPzKQs",
        tag: "Coronation",
    },
    {
        title: "Dry Fasting & Pentecostal Period",
        description:
            "A sacred season of spiritual discipline, fasting and intense prayer as brethren seek the face of God in preparation for the outpouring.",
        vidlink: "https://youtube.com/embed/FQVSrVSkbC4",
        tag: "Fasting",
    },
    {
        title: "Supreme Signature",
        description:
            "It marks the supreme authority of the King of Kings. Whatever He appends the signature remains sacrosanct — the highest authority every spirit submits to.",
        vidlink: "https://www.youtube.com/embed/YXEzm7_BCCo?si=WdCyAqASF9R3VTUf",
        tag: "Authority",
    },
    {
        title: "Eton Day",
        description:
            "On 8th August 1958, BCS was revealed to the universe as members dressed in heavenly robes and marched from Eton Street — signifying the Kingdom rising to greater heights.",
        vidlink: "https://youtube.com/embed/9e08oSB_cvc",
        tag: "Anniversary",
    },
    {
        title: "Holy Mother's Glorification",
        description:
            "The Holy Mother was the pillar and backbone of BCS. Her love and mercy for humanity is incomparable — this day honours her eternal legacy.",
        vidlink: "https://youtube.com/embed/2aKFJIoQe7k",
        tag: "Memorial",
    },
    {
        title: "Divine Manifestation of King of Kings And Lord of Lords",
        description:
            "Celebrated like Christmas, this marks the day His Holiness Olumba Olumba Obu was brought to earth to rule and judge the entire universe. High point: the Feast of the Lamb.",
        vidlink: "https://youtube.com/embed/rG8viOhTQ_Y",
        tag: "Manifestation",
    },
    {
        title: "Divine Manifestation of the Ancient of Days",
        description:
            "30th December marks the physical manifestation of Leader Olumba Olumba Obu in Biakpan, Cross River State — the founder, leader and sustainer of the BCS Kingdom.",
        vidlink: "https://youtube.com/embed/SOJhRqd3rUE",
        tag: "Manifestation",
    },
    {
        title: "Music & Merit Award Night",
        description:
            "A night of celebration honoring excellence, divine music and the faithful servants of the Brotherhood across all nations of the earth.",
        vidlink: "https://youtube.com/embed/dMZNtCY3bhk",
        tag: "Awards",
    },
];

const tagColors = {
    Spiritual: "text-blue-600 bg-blue-50 border-blue-100",
    Coronation: "text-amber-600 bg-amber-50 border-amber-100",
    Fasting: "text-purple-600 bg-purple-50 border-purple-100",
    Authority: "text-red-600 bg-red-50 border-red-100",
    Anniversary: "text-green-600 bg-green-50 border-green-100",
    Memorial: "text-pink-600 bg-pink-50 border-pink-100",
    Manifestation: "text-indigo-600 bg-indigo-50 border-indigo-100",
    Awards: "text-orange-600 bg-orange-50 border-orange-100",
};

const Events = () => {
    return (
        <div className="bg-white min-h-screen">

            {/* ── Hero ── */}
            <div className="relative w-full h-[40vh] md:h-[50vh] mt-32 md:mt-36 overflow-hidden">
                <img
                    src="https://firebasestorage.googleapis.com/v0/b/bcs-public-portal.appspot.com/o/BCS_WEBITE_ASSETS%2FEvents.jpg?alt=media&token=fd8aba22-9698-422c-884d-202a7939da05"
                    alt="BCS Events"
                    className="w-full h-full object-cover object-center"
                />

            </div>

            {/* ── Intro ── */}
            <div className="max-w-3xl mx-auto px-6 md:px-10 pt-16 pb-4 text-center">
                <div className="flex items-center justify-center gap-2 mb-4">
                    <span className="block w-7 h-px bg-red-600" />
                    <span className="text-red-600 text-[10px] font-bold tracking-widest uppercase">Our Events</span>
                    <span className="block w-7 h-px bg-red-600" />
                </div>
                <p className="text-gray-400 text-sm leading-relaxed">
                    Brotherhood of the Cross and Star is a global divine institution. It teaches and
                    practices Universal love, peace, unity, truth and righteousness in the Holy Spirit.
                    The World Headquarters situates at No. 34 Ambo Street, Calabar, Nigeria.
                </p>
            </div>

            {/* ── Events list ── */}
            <div className="max-w-5xl mx-auto px-5 md:px-10 py-14 space-y-20">
                {events.map((event, index) => {
                    const isEven = index % 2 === 0;
                    return (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 0.5 }}
                            className={`flex flex-col ${isEven ? "md:flex-row" : "md:flex-row-reverse"} items-center gap-10 md:gap-14`}
                        >
                            {/* ── Video ── */}
                            <div className="w-full md:w-1/2 flex-shrink-0">
                                <div className="relative w-full aspect-video rounded-sm overflow-hidden border border-gray-100">
                                    <iframe
                                        src={event.vidlink}
                                        title={event.title}
                                        className="absolute inset-0 w-full h-full"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                    />
                                </div>
                            </div>

                            {/* ── Text ── */}
                            <div className="w-full md:w-1/2 flex flex-col gap-4">

                                {/* Number + tag */}
                                <div className="flex items-center gap-3">
                                    <span className="text-[10px] font-black text-gray-200 tracking-widest">
                                        {String(index + 1).padStart(2, "0")}
                                    </span>
                                    <span className={`text-[9px] font-bold tracking-widest uppercase border px-2 py-0.5 rounded-sm ${tagColors[event.tag] || "text-gray-400 bg-gray-50 border-gray-100"}`}>
                                        {event.tag}
                                    </span>
                                </div>

                                {/* Title */}
                                <h2 className="text-2xl md:text-3xl font-bold text-gray-900 leading-tight">
                                    {event.title}
                                </h2>

                                {/* Divider */}
                                <div className="w-10 h-0.5 bg-red-500" />

                                {/* Description */}
                                <p className="text-gray-500 text-sm leading-relaxed">
                                    {event.description}
                                </p>
                            </div>
                        </motion.div>
                    );
                })}
            </div>

        </div>
    );
};

export default Events;